import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "../../../../adapter-vue";
import TUIChatEngine, {
  IMessageModel,
} from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import MessageQuote from "./message-quote/index.vue";
import loadingIcon from "../../../../assets/icon/loading.png";

interface IProps {
  messageItem: IMessageModel;
  content?: any;
  blinkMessageIDList?: string[];
}

interface IEmits {
  (e: 'resendMessage'): void;
  (e: 'blinkMessage', messageID: string): void;
  // 下面的方法是 uniapp 专属
  (e: 'scrollTo', scrollHeight: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-bubble',
  props: {
    messageItem: { default: () => ({} as IMessageModel) },
    content: { default: () => ({}) },
    blinkMessageIDList: { default: () => [] }
  },
  emits: ["resendMessage", "blinkMessage", "scrollTo"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'resendMessage'): void;
  (e: 'blinkMessage', messageID: string): void;
  // 下面的方法是 uniapp 专属
  (e: 'scrollTo', scrollHeight: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { messageItem: IMessageModel, content: any, blinkMessageIDList: string[] }





const TYPES = TUIChatEngine.TYPES;
const defaultAvatarUrl = 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png';
const needLoadingIconMessageType = [
  TYPES.MSG_LOCATION,
  TYPES.MSG_TEXT,
  TYPES.MSG_CUSTOM,
  TYPES.MSG_MERGER,
  TYPES.MSG_FACE
];

const {
  blinkMessageIDList,
  messageItem: message
} = toRefs(props);


const isNoPadding = computed(() => {
  return [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO].includes(message.value.type);
});

const isBlink = computed(() => {
  if (message.value?.ID) {
    return blinkMessageIDList?.value?.includes(message.value.ID);
  }
  return false;
});

function resendMessage() {
  emits("resendMessage");
}

function blinkMessage(messageID: string) {
  emits('blinkMessage', messageID);
}

function scrollTo(scrollHeight: number) {
  emits('scrollTo', scrollHeight);
}

return { __sfc: true,emits, props, TYPES, defaultAvatarUrl, needLoadingIconMessageType, blinkMessageIDList, message, isNoPadding, isBlink, resendMessage, blinkMessage, scrollTo, Icon, MessageQuote, loadingIcon }
}

})